import React, { useContext, useState, useEffect } from 'react'
import { useLocation, NavLink } from 'react-router-dom'
import { Capitalize } from '../utils/functions/tools/capitalizeString'

const ClientNav = (profile) => {
  //variables
  let [pageName, setPageName] = useState(null)

  //assigning location variable
  const location = useLocation();

  //destructuring pathname from location
  const { pathname } = location;

  //Javascript split method to get the name of the path in array
  const splitLocation = pathname.split("/");

  //active page name
  useEffect(() => {
    setPageName(Capitalize(splitLocation[3]))
  })

  return (
    <div className="col-12 col-sm-12 col-md-3 mb-1">
      <ul aria-labelledby="id2__label" className="tree bx--tree" role="tree">
        <li id="1" tabIndex="0" aria-current={splitLocation[2] === "dashboard" ? "true" : "false"} aria-selected={splitLocation[2] === "dashboard" ? "true" : "false"} className={splitLocation[2] === "dashboard" ? "bx--tree-node bx--tree-node--active bx--tree-node--selected bx--tree-leaf-node" : "bx--tree-node bx--tree-leaf-node"} role="treeitem">
          <a href={`/client/dashboard/${profile.profileId}`} className="bx--tree-node__label ml-neg-25 pl-25 dec-none">
            <span>Dashboard</span>
          </a>
        </li>
        <li id="2" tabIndex="-1" aria-current={splitLocation[2] === "details" ? "true" : ""} aria-selected={splitLocation[2] === "details" ? "true" : "false"} className={splitLocation[2] === "details" ? "bx--tree-node bx--tree-node--active bx--tree-node--selected bx--tree-leaf-node" : "bx--tree-node bx--tree-leaf-node"} role="treeitem">
          <a href={`/client/details/${profile.profileId}`} className="bx--tree-node__label ml-neg-25 pl-25 dec-none">
            <span>Details</span>
          </a>
        </li>
        <li id="2" tabIndex="-1" aria-current={splitLocation[2] === "contacts" ? "true" : ""} aria-selected={splitLocation[2] === "contacts" ? "true" : "false"} className={splitLocation[2] === "contacts" ? "bx--tree-node bx--tree-node--active bx--tree-node--selected bx--tree-leaf-node" : "bx--tree-node bx--tree-leaf-node"} role="treeitem">
          <a href={`/client/contacts/${profile.profileId}`} className="bx--tree-node__label ml-neg-25 pl-25 dec-none">
            <span>Contacts</span>
          </a>
        </li>
        <li id="2" tabIndex="-1" aria-current={splitLocation[2] === "notes" ? "true" : ""} aria-selected={splitLocation[2] === "notes" ? "true" : "false"} className={splitLocation[2] === "notes" ? "bx--tree-node bx--tree-node--active bx--tree-node--selected bx--tree-leaf-node" : "bx--tree-node bx--tree-leaf-node"} role="treeitem">
          <a href={`/client/notes/${profile.profileId}`} className="bx--tree-node__label ml-neg-25 pl-25 dec-none">
            <span>Notes</span>
          </a>
        </li>
        <li id="2" tabIndex="-1" aria-current={splitLocation[2] === "settings" ? "true" : ""} aria-selected={splitLocation[2] === "settings" ? "true" : "false"} className={splitLocation[2] === "settings" ? "bx--tree-node bx--tree-node--active bx--tree-node--selected bx--tree-leaf-node" : "bx--tree-node bx--tree-leaf-node"} role="treeitem">
          <a href={`/client/settings/${profile.profileId}`} className="bx--tree-node__label ml-neg-25 pl-25 dec-none">
            <span>Settings</span>
          </a>
        </li>
        <li id="2" tabIndex="-1" aria-current={splitLocation[2] === "activity" ? "true" : ""} aria-selected={splitLocation[2] === "activity" ? "true" : "false"} className={splitLocation[2] === "activity" ? "bx--tree-node bx--tree-node--active bx--tree-node--selected bx--tree-leaf-node" : "bx--tree-node bx--tree-leaf-node"} role="treeitem">
          <a href={`/client/activity/${profile.profileId}`} className="bx--tree-node__label ml-neg-25 pl-25 dec-none">
            <span>Activity</span>
          </a>
        </li>
      </ul>
    </div>
  )
}

export default ClientNav